import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonewaycabservice() {



  const cardData = {
"keyword": "Pune One Way Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and affordable Pune One Way Cab Service for travelers who need convenient point-to-point transportation without paying for a return trip. Whether you are traveling to Mumbai, Nashik, Shirdi, Goa, Kolhapur, Aurangabad, or nearby destinations, our one-way taxi service ensures a smooth, safe, and cost-effective journey. With professional drivers, well-maintained air-conditioned cars, and transparent pricing with no hidden charges, we provide a hassle-free travel experience for individuals, families, and business travelers. Our fleet includes sedans, SUVs, and premium vehicles, with easy online booking, doorstep pickup, and 24/7 customer support for flexible intercity travel from Pune.",

"topPlaces": [
  {
    "title": "Mumbai",
    "description":
      "Mumbai is one of the most popular destinations from Pune, known for business hubs, beaches, and entertainment. Pune One Way Cab Service offers comfortable and direct travel between Pune and Mumbai at affordable rates."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for temples, vineyards, and religious tourism. One-way cab services from Pune provide a convenient and budget-friendly travel option to this cultural city."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba and attracts devotees from all over India. One-way cabs from Pune make spiritual travel easy and comfortable."
  },
  {
    "title": "Goa",
    "description":
      "Goa is a famous beach destination known for nightlife, beaches, and tourism activities. Pune One Way Cab Service offers long-distance comfortable travel for holiday trips."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is known for Mahalaxmi Temple, traditional cuisine, and rich culture. One-way taxi service from Pune provides a smooth and affordable travel option."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is famous for Ajanta and Ellora caves along with historical monuments. One-way cab service from Pune makes heritage travel convenient and hassle-free."
  },
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a popular hill station near Pune known for waterfalls, greenery, and scenic views. One-way cabs are perfect for quick weekend trips and short-distance travel."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a beautiful hill station with cool weather, viewpoints, and strawberry farms. Pune one-way cab service ensures a comfortable journey to this tourist hotspot."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal destination known for beaches and peaceful getaways. One-way cab services from Pune provide easy access for weekend relaxation trips."
  },
  {
    "title": "Satara",
    "description":
      "Satara is known for natural beauty, forts, and waterfalls in the Sahyadri region. One-way taxi service from Pune is ideal for scenic and budget-friendly travel."
  }
],



services: [
  {
    name: "Pune One Way Cab Service",
    description: "Pune one way cab service provides reliable transportation for passengers traveling from Pune to local and outstation destinations without return travel requirements. Comfortable vehicles with experienced drivers ensure smooth city and highway journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel needs. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "One Way Taxi Pune",
    description: "One way taxi Pune service offers convenient transportation for passengers traveling from Pune to nearby cities and tourist destinations. Comfortable vehicles provide smooth highway travel suitable for airport transfers, business trips, and family travel requirements. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from residential areas, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow easy one-way taxi reservations."
  },
  {
    name: "One Side Cab Pune",
    description: "One side cab Pune service provides economical transportation for passengers looking for single-trip travel from Pune to local and outstation locations. Vehicles ensure comfortable seating and reliable highway travel suitable for long-distance journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-side cab reservations."
  },
  {
    name: "Drop Taxi Pune",
    description: "Drop taxi Pune service offers dependable transportation for passengers requiring one-way drop services from Pune to various destinations. Comfortable vehicles provide smooth city and highway travel suitable for airport transfers, business meetings, tourism, and family visits. Professional chauffeurs ensure punctual pickup and safe transportation services. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient drop taxi reservations."
  },
  {
    name: "Intercity One Way Cab Pune",
    description: "Intercity one way cab Pune service provides reliable transportation between Pune and nearby cities with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway and highway travel ensuring smooth and safe journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business travel, tourism, airport transfers, and family trips. Flexible booking options allow convenient intercity one-way cab reservations."
  },
  {
    name: "Pune to City One Way Taxi",
    description: "Pune to city one way taxi service offers dependable transportation from Pune to major cities and nearby destinations. Comfortable vehicles ensure smooth long-distance travel with professional drivers maintaining passenger safety and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Ideal for business travel, tourism, and personal journeys. Flexible booking options allow convenient one-way taxi reservations."
  },
  {
    name: "One Way Cab Booking Pune",
    description: "One way cab booking Pune service allows passengers to reserve taxis for convenient single-trip journeys from Pune to various destinations. Vehicles include sedans, SUVs, luxury cars, and premium taxis suitable for different travel requirements. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow instant and advance one-way cab reservations."
  },
  {
    name: "Affordable One Way Cab Pune",
    description: "Affordable one way cab Pune service provides budget-friendly transportation for passengers looking for economical single-trip travel from Pune. Comfortable vehicles ensure reliable city and highway travel while maintaining affordable pricing for travelers. Professional drivers ensure safe journeys and punctual pickup services throughout Pune and nearby destinations. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient and affordable one-way cab reservations."
  },
  {
    name: "Cheap One Way Taxi Pune",
    description: "Cheap one way taxi Pune service offers economical transportation for passengers traveling from Pune to local and outstation destinations. Comfortable vehicles provide smooth travel experience suitable for airport transfers, office travel, and family trips at affordable pricing. Professional drivers ensure safe driving and timely pickup services across Pune. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient low-cost one-way taxi reservations."
  },
  {
    name: "Best One Way Cab Pune",
    description: "Best one way cab Pune service provides premium transportation with comfortable vehicles and experienced chauffeurs for reliable single-trip travel. Vehicles offer spacious seating and smooth ride quality suitable for long-distance journeys and airport transfers. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "One Way Outstation Cab Pune",
    description: "One way outstation cab Pune service provides dependable transportation for passengers traveling from Pune to tourist destinations, business cities, and pilgrimage locations without return travel. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for comfortable highway journeys. Professional drivers ensure safe driving and smooth travel experience throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation one-way cab reservations."
  },
  {
    name: "Long Distance One Way Taxi Pune",
    description: "Long distance one way taxi Pune service offers reliable transportation for passengers planning extended highway journeys from Pune to distant destinations. Comfortable vehicles provide spacious seating and luggage capacity suitable for long-route travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient long-distance one-way taxi reservations."
  },
  {
    name: "Sedan One Way Cab Pune",
    description: "Sedan one way cab Pune service provides economical and comfortable transportation for solo travelers, couples, and small families traveling from Pune. Sedan vehicles ensure smooth city and highway travel suitable for airport transfers, business trips, and tourism journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient sedan one-way cab reservations."
  },
  {
    name: "SUV One Way Taxi Pune",
    description: "SUV one way taxi Pune service provides spacious transportation for families and groups traveling from Pune to nearby and outstation destinations. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient SUV one-way taxi reservations."
  },
  {
    name: "Instant One Way Cab Pune",
    description: "Instant one way cab Pune service offers quick transportation solutions for passengers requiring immediate single-trip travel from Pune. Comfortable vehicles ensure reliable city and highway travel suitable for emergency trips, airport transfers, and business journeys. Professional drivers ensure fast pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient instant one-way cab reservations."
  },
  {
    name: "Pune to Mumbai One Way Cab",
    description: "Pune to Mumbai one way cab service provides reliable transportation between Pune and Mumbai with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Ideal for business travel, airport transfers, tourism, and family visits. Flexible booking options allow convenient one-way cab reservations."
  }
],

tableData: [
  ["Pune One Way Cab Service", "One Way Taxi Pune"],
  ["One Side Cab Pune", "Drop Taxi Pune"],
  ["Intercity One Way Cab Pune", "Pune to City One Way Taxi"],
  ["One Way Cab Booking Pune", "Affordable One Way Cab Pune"],
  ["Cheap One Way Taxi Pune", "Best One Way Cab Pune"],
  ["One Way Outstation Cab Pune", "Long Distance One Way Taxi Pune"],
  ["Sedan One Way Cab Pune", "SUV One Way Taxi Pune"],
  ["Instant One Way Cab Pune", "Pune to Mumbai One Way Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Affordable One Way Cab Service",
        WhyChoosedescription: "Shivai Travels provides affordable Pune one way cab service for local and outstation travel. Customers can enjoy budget-friendly one-way taxi fares without paying unnecessary round-trip charges."
      },
      {
        WhyChooseheading: "Transparent One Way Taxi Pricing",
        WhyChoosedescription: "Shivai Travels offers transparent pricing for Pune one way cab service with clear fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 One Way Cab Availability",
        WhyChoosedescription: "Our Pune one way cab service operates 24 hours a day for airport transfers, business travel, emergency transportation, family trips, and outstation journeys."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Vehicles",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide safe and comfortable travel experiences for passengers."
      },
      {
        WhyChooseheading: "Flexible One Way Travel Options",
        WhyChoosedescription: "Shivai Travels offers one-way taxi service from Pune to Mumbai, Nashik, Kolhapur, Shirdi, Mahabaleshwar, Lonavala, Goa, and many other popular destinations."
      },
      {
        WhyChooseheading: "Wide Range of One Way Taxi Vehicles",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for solo travelers, families, and corporate groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides doorstep pickup from homes, offices, hotels, Pune Airport, railway stations, and major Pune areas including Baner, Wakad, Kharadi, Hinjewadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Reliable Pune One Way Taxi Service",
        WhyChoosedescription: "Shivai Travels is trusted for reliable Pune one way cab service with punctual drivers, professional support, comfortable vehicles, and smooth intercity transportation."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune one way cab service?", answer: "Pune one way cab service provides taxi transportation from Pune to another destination without requiring a return booking." },
    { question: "Is Pune one way cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 one way taxi service from Pune." },
    { question: "Which vehicles are available for one way travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Mumbai?", answer: "Yes, Shivai Travels provides one-way taxi service from Pune to Mumbai and many other destinations." },
    { question: "Do you provide Pune Airport pickup for one-way travel?", answer: "Yes, Shivai Travels provides airport pickup and drop services for one-way journeys." },
    { question: "Are all one-way taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune one way cab service online?", answer: "Yes, customers can easily book Pune one way cab service online or through phone booking." },
    { question: "Do you provide one-way cabs for family trips?", answer: "Yes, Shivai Travels provides comfortable one-way taxi services for family vacations and group travel." },
    { question: "Are one-way taxi fares affordable?", answer: "Yes, Shivai Travels offers affordable and transparent one-way taxi pricing without hidden charges." },
    { question: "Is advance booking available for one-way cab service?", answer: "Yes, advance booking is available and recommended during weekends and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Sameer Patil",
      feedback:
        "Booked Pune one way cab service with Shivai Travels. Affordable fare, clean cab, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Neeta Kulkarni",
      feedback:
        "Very reliable one-way taxi service from Pune. Smooth travel experience and transparent pricing.",
      rating: 5
    }
  ];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune One Way Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-one-way-cab.jpg",
  "description": "Book Pune one way cab service for affordable and comfortable intercity travel. Shivai Travels provides one side taxi booking, outstation one-way cabs, sedan and SUV taxi options with instant confirmation and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-one-way-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune One Way Cab Service | Affordable One Side Taxi Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune one way cab service for affordable intercity and outstation travel. One side taxi booking with sedan, SUV, and AC cabs available 24x7 at budget-friendly prices."
  />

  <meta
    name="keywords"
    content="Pune one way cab service, one way taxi pune, one side cab pune, drop taxi pune, intercity one way cab pune, pune to city one way taxi, one way cab booking pune, affordable one way cab pune, cheap one way taxi pune, best one way cab pune, one way outstation cab pune, long distance one way taxi pune, sedan one way cab pune, suv one way taxi pune, instant one way cab pune, Pune One Way Cab Service, One Way Cab Pune, One Way Taxi Service Pune, Pune One Side Cab Booking, Best One Way Cab in Pune, Cheap One Way Cab Pune, Online One Way Cab Booking Pune, 24x7 One Way Taxi Pune, Outstation One Way Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneonewaycabservice;